function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach(video => video.pause());
    document.querySelectorAll('product-model').forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Cover-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();

        if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        }
    }

}

customElements.define('deferred-media', DeferredMedia);

// Video section: Shopify-hosted video. Starts loading and playing only when in view, pauses when out of view,
// and never autoplays for visitors who prefer reduced motion (they get the cover image and a play button).
class VideoSectionPlayer extends HTMLElement {
    connectedCallback() {
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('.VideoSection__PlayButton');
        if (!this.video) return;

        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.shouldPlay = this.dataset.autoplay === 'true' && !reducedMotion;
        this.inView = false;

        if (this.playButton) this.playButton.addEventListener('click', this.start.bind(this));
        this.video.addEventListener('click', this.toggle.bind(this));
        if (!this.shouldPlay) this.showButton(true);

        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    this.inView = entry.isIntersecting;
                    if (this.inView && this.shouldPlay) this.play();
                    if (!this.inView) this.video.pause();
                });
            }, { threshold: 0.25 });
            this.observer.observe(this);
        } else if (this.shouldPlay) {
            this.play();
        }
    }

    disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
    }

    play() {
        if (this.video.preload === 'none') this.video.preload = 'auto';
        const attempt = this.video.play();
        if (attempt && attempt.catch) attempt.catch(() => this.showButton(true));
        this.showButton(false);
    }

    start() {
        this.shouldPlay = true;
        this.play();
    }

    toggle() {
        if (this.video.controls) return;
        if (this.video.paused) {
            this.start();
        } else {
            this.shouldPlay = false;
            this.video.pause();
            this.showButton(true);
        }
    }

    showButton(show) {
        if (this.playButton) this.playButton.style.display = show ? '' : 'none';
    }
}

if (!customElements.get('video-section-player')) customElements.define('video-section-player', VideoSectionPlayer);
